"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4995],{

/***/ 63705:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ featureFarmApiAtom; },
  "y": function() { return /* binding */ useFeatureFlag; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
;// CONCATENATED MODULE: ./src/config/flag.ts
var FLAG_FARM = "pkg";

// EXTERNAL MODULE: ../../node_modules/jotai/esm/index.mjs + 1 modules
var esm = __webpack_require__(50154);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/utils.mjs + 1 modules
var utils = __webpack_require__(61003);
;// CONCATENATED MODULE: ./src/hooks/useFeatureFlag.ts





var storage = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* createJSONStorage */.FL)(function() {
    return sessionStorage;
})), {
    delayInit: true
});
var featureFarmApiAtom = (0,utils/* atomWithStorage */.O4)("feature-farm-api", FLAG_FARM, // @ts-ignore
storage);
featureFarmApiAtom.onMount = function(set) {
    var params = new URL(window.location.href).searchParams;
    var flag = params.get("use");
    if (flag === "farmApi") {
        set("api");
    }
};
function useFeatureFlag(featureAtom) {
    return (0,esm/* useAtomValue */.Dv)(featureAtom);
}


/***/ }),

/***/ 11885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useSlowRefreshEffect; },
/* harmony export */   "a": function() { return /* binding */ useFastRefreshEffect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57535);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3255);
/* harmony import */ var _useActiveChainId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15112);





var EMPTY_ARRAY = [];
function useFastRefreshEffect(effect, deps) {
    var chainId = (0,_useActiveChainId__WEBPACK_IMPORTED_MODULE_3__/* .useActiveChainId */ .g)().chainId;
    var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(chainId && [
        config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FAST_INTERVAL */ .sR,
        "blockNumber",
        chainId
    ]), _useSWR_data = _useSWR.data, data = _useSWR_data === void 0 ? 0 : _useSWR_data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect.bind(null, data), [
        data
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(deps || EMPTY_ARRAY)));
}
function useSlowRefreshEffect(effect, deps) {
    var chainId = (0,_useActiveChainId__WEBPACK_IMPORTED_MODULE_3__/* .useActiveChainId */ .g)().chainId;
    var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(chainId && [
        config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SLOW_INTERVAL */ .KI,
        "blockNumber",
        chainId
    ]), _useSWR_data = _useSWR.data, data = _useSWR_data === void 0 ? 0 : _useSWR_data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect.bind(null, data), [
        data
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(deps || EMPTY_ARRAY)));
}


/***/ }),

/***/ 79524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ useFarmFromPid; },
  "Dx": function() { return /* binding */ useFarmUser; },
  "E2": function() { return /* binding */ useFarms; },
  "f5": function() { return /* binding */ useFarmsLength; },
  "w5": function() { return /* binding */ useLpTokenPrice; },
  "Cs": function() { return /* binding */ usePollFarmsWithUserData; },
  "Iu": function() { return /* binding */ usePriceCakeBusd; }
});

// UNUSED EXPORTS: useBusdPriceFromPid, useFarmFromLpSymbol, useFarmsPoolLength, usePollCoreFarmData

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(90327);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(57535);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(14024);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(43997);
// EXTERNAL MODULE: ./src/state/index.ts + 16 modules
var state = __webpack_require__(95625);
// EXTERNAL MODULE: ../../node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(2303);
// EXTERNAL MODULE: ../../packages/utils/bigNumber.ts
var bigNumber = __webpack_require__(52785);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(70688);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 26 modules
var contractHelpers = __webpack_require__(36561);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(11885);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlag.ts + 1 modules
var hooks_useFeatureFlag = __webpack_require__(63705);
// EXTERNAL MODULE: ../../packages/farms/constants/index.ts
var farms_constants = __webpack_require__(30231);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var hooks_useActiveChainId = __webpack_require__(15112);
// EXTERNAL MODULE: ./src/state/farms/index.ts
var farms = __webpack_require__(97013);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(61973);
// EXTERNAL MODULE: ../../packages/utils/formatBalance.ts
var formatBalance = __webpack_require__(242);
// EXTERNAL MODULE: ../../packages/utils/isUndefinedOrNull.ts
var isUndefinedOrNull = __webpack_require__(71561);
// EXTERNAL MODULE: ../../packages/token-lists/dist/chunk-YBVZDUCZ.mjs
var chunk_YBVZDUCZ = __webpack_require__(13776);
// EXTERNAL MODULE: ../../node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(5994);
;// CONCATENATED MODULE: ./src/state/farms/selectors.ts








var deserializeFarmUserData = function(farm) {
    var _farm_userData, _farm_userData1, _farm_userData2, _farm_userData3, _farm_userData4, _farm_userData5, _farm_userData6, _farm_userData7;
    return {
        allowance: farm.userData ? new (bignumber_default())(farm.userData.allowance) : bigNumber/* BIG_ZERO */.HW,
        tokenBalance: farm.userData ? new (bignumber_default())(farm.userData.tokenBalance) : bigNumber/* BIG_ZERO */.HW,
        stakedBalance: farm.userData ? new (bignumber_default())(farm.userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW,
        earnings: farm.userData ? new (bignumber_default())(farm.userData.earnings) : bigNumber/* BIG_ZERO */.HW,
        proxy: {
            allowance: (farm === null || farm === void 0 ? void 0 : (_farm_userData = farm.userData) === null || _farm_userData === void 0 ? void 0 : _farm_userData.proxy) ? new (bignumber_default())(farm === null || farm === void 0 ? void 0 : (_farm_userData1 = farm.userData) === null || _farm_userData1 === void 0 ? void 0 : _farm_userData1.proxy.allowance) : bigNumber/* BIG_ZERO */.HW,
            tokenBalance: (farm === null || farm === void 0 ? void 0 : (_farm_userData2 = farm.userData) === null || _farm_userData2 === void 0 ? void 0 : _farm_userData2.proxy) ? new (bignumber_default())(farm === null || farm === void 0 ? void 0 : (_farm_userData3 = farm.userData) === null || _farm_userData3 === void 0 ? void 0 : _farm_userData3.proxy.tokenBalance) : bigNumber/* BIG_ZERO */.HW,
            stakedBalance: (farm === null || farm === void 0 ? void 0 : (_farm_userData4 = farm.userData) === null || _farm_userData4 === void 0 ? void 0 : _farm_userData4.proxy) ? new (bignumber_default())(farm === null || farm === void 0 ? void 0 : (_farm_userData5 = farm.userData) === null || _farm_userData5 === void 0 ? void 0 : _farm_userData5.proxy.stakedBalance) : bigNumber/* BIG_ZERO */.HW,
            earnings: (farm === null || farm === void 0 ? void 0 : (_farm_userData6 = farm.userData) === null || _farm_userData6 === void 0 ? void 0 : _farm_userData6.proxy) ? new (bignumber_default())(farm === null || farm === void 0 ? void 0 : (_farm_userData7 = farm.userData) === null || _farm_userData7 === void 0 ? void 0 : _farm_userData7.proxy.earnings) : bigNumber/* BIG_ZERO */.HW
        }
    };
};
var deserializeFarm = function(farm) {
    var lpAddress = farm.lpAddress, lpSymbol = farm.lpSymbol, pid = farm.pid, vaultPid = farm.vaultPid, dual = farm.dual, multiplier = farm.multiplier, isCommunity = farm.isCommunity, auctionHostingStartSeconds = farm.auctionHostingStartSeconds, quoteTokenPriceBusd = farm.quoteTokenPriceBusd, tokenPriceBusd = farm.tokenPriceBusd, boosted = farm.boosted, infoStableSwapAddress = farm.infoStableSwapAddress, stableSwapAddress = farm.stableSwapAddress;
    var auctionHostingStartDate = !(0,isUndefinedOrNull/* default */.Z)(auctionHostingStartSeconds) ? new Date(auctionHostingStartSeconds * 1000) : null;
    var auctionHostingEndDate = auctionHostingStartDate ? (0,addSeconds/* default */.Z)(auctionHostingStartDate, constants/* FARM_AUCTION_HOSTING_IN_SECONDS */.ki) : null;
    var now = Date.now();
    var isFarmCommunity = isCommunity || !!(auctionHostingStartDate && auctionHostingEndDate && auctionHostingStartDate.getTime() < now && auctionHostingEndDate.getTime() > now);
    return {
        lpAddress: lpAddress,
        lpSymbol: lpSymbol,
        pid: pid,
        vaultPid: vaultPid,
        dual: dual,
        multiplier: multiplier,
        isCommunity: isFarmCommunity,
        auctionHostingEndDate: auctionHostingEndDate === null || auctionHostingEndDate === void 0 ? void 0 : auctionHostingEndDate.toJSON(),
        quoteTokenPriceBusd: quoteTokenPriceBusd,
        tokenPriceBusd: tokenPriceBusd,
        token: (0,chunk_YBVZDUCZ/* deserializeToken */.iG)(farm.token),
        quoteToken: (0,chunk_YBVZDUCZ/* deserializeToken */.iG)(farm.quoteToken),
        userData: deserializeFarmUserData(farm),
        tokenAmountTotal: farm.tokenAmountTotal ? new (bignumber_default())(farm.tokenAmountTotal) : bigNumber/* BIG_ZERO */.HW,
        quoteTokenAmountTotal: farm.quoteTokenAmountTotal ? new (bignumber_default())(farm.quoteTokenAmountTotal) : bigNumber/* BIG_ZERO */.HW,
        lpTotalInQuoteToken: farm.lpTotalInQuoteToken ? new (bignumber_default())(farm.lpTotalInQuoteToken) : bigNumber/* BIG_ZERO */.HW,
        lpTotalSupply: farm.lpTotalSupply ? new (bignumber_default())(farm.lpTotalSupply) : bigNumber/* BIG_ZERO */.HW,
        lpTokenPrice: farm.lpTokenPrice ? new (bignumber_default())(farm.lpTokenPrice) : bigNumber/* BIG_ZERO */.HW,
        tokenPriceVsQuote: farm.tokenPriceVsQuote ? new (bignumber_default())(farm.tokenPriceVsQuote) : bigNumber/* BIG_ZERO */.HW,
        poolWeight: farm.poolWeight ? new (bignumber_default())(farm.poolWeight) : bigNumber/* BIG_ZERO */.HW,
        boosted: boosted,
        isStable: Boolean(infoStableSwapAddress),
        stableSwapAddress: stableSwapAddress
    };
};
var selectCakeFarm = function(state) {
    return state.farms.data.find(function(f) {
        return f.pid === 2;
    });
};
var selectFarmByKey = function(key, value) {
    return function(state) {
        return state.farms.data.find(function(f) {
            return f[key] === value;
        });
    };
};
var makeFarmFromPidSelector = function(pid) {
    return (0,reselect_es/* createSelector */.P1)([
        selectFarmByKey("pid", pid)
    ], function(farm) {
        return deserializeFarm(farm);
    });
};
var selectors_makeBusdPriceFromPidSelector = function(pid) {
    return createSelector([
        selectFarmByKey("pid", pid)
    ], function(farm) {
        return farm && new BigNumber(farm.tokenPriceBusd);
    });
};
var makeUserFarmFromPidSelector = function(pid) {
    return (0,reselect_es/* createSelector */.P1)([
        selectFarmByKey("pid", pid)
    ], function(farm) {
        var _deserializeFarmUserData = deserializeFarmUserData(farm), allowance = _deserializeFarmUserData.allowance, tokenBalance = _deserializeFarmUserData.tokenBalance, stakedBalance = _deserializeFarmUserData.stakedBalance, earnings = _deserializeFarmUserData.earnings, proxy = _deserializeFarmUserData.proxy;
        return {
            allowance: allowance,
            tokenBalance: tokenBalance,
            stakedBalance: stakedBalance,
            earnings: earnings,
            proxy: proxy
        };
    });
};
var priceCakeFromPidSelector = (0,reselect_es/* createSelector */.P1)([
    selectCakeFarm
], function(cakeBnbFarm) {
    var cakePriceBusdAsString = cakeBnbFarm === null || cakeBnbFarm === void 0 ? void 0 : cakeBnbFarm.tokenPriceBusd;
    return new (bignumber_default())(cakePriceBusdAsString);
});
var selectors_farmFromLpSymbolSelector = function(lpSymbol) {
    return createSelector([
        selectFarmByKey("lpSymbol", lpSymbol)
    ], function(farm) {
        return deserializeFarm(farm);
    });
};
var makeLpTokenPriceFromLpSymbolSelector = function(lpSymbol) {
    return (0,reselect_es/* createSelector */.P1)([
        selectFarmByKey("lpSymbol", lpSymbol)
    ], function(farm) {
        var lpTokenPrice = bigNumber/* BIG_ZERO */.HW;
        if (farm) {
            var lpTotalInQuoteToken = farm.lpTotalInQuoteToken ? new (bignumber_default())(farm.lpTotalInQuoteToken) : bigNumber/* BIG_ZERO */.HW;
            var lpTotalSupply = farm.lpTotalSupply ? new (bignumber_default())(farm.lpTotalSupply) : bigNumber/* BIG_ZERO */.HW;
            if (lpTotalSupply.gt(0) && lpTotalInQuoteToken.gt(0)) {
                var farmTokenPriceInUsd = new (bignumber_default())(farm.tokenPriceBusd);
                var tokenAmountTotal = farm.tokenAmountTotal ? new (bignumber_default())(farm.tokenAmountTotal) : bigNumber/* BIG_ZERO */.HW;
                // Total value of base token in LP
                var valueOfBaseTokenInFarm = farmTokenPriceInUsd.times(tokenAmountTotal);
                // Double it to get overall value in LP
                var overallValueOfAllTokensInFarm = valueOfBaseTokenInFarm.times(2);
                // Divide total value of all tokens, by the number of LP tokens
                var totalLpTokens = (0,formatBalance/* getBalanceAmount */.U4)(lpTotalSupply);
                lpTokenPrice = overallValueOfAllTokensInFarm.div(totalLpTokens);
            }
        }
        return lpTokenPrice;
    });
};
var farmSelector = function(chainId) {
    return (0,reselect_es/* createSelector */.P1)(function(state) {
        return state.farms;
    }, function(farms) {
        var deserializedFarmsData = farms.data.map(deserializeFarm).filter(function(farm) {
            return farm.token.chainId === chainId;
        });
        var loadArchivedFarmsData = farms.loadArchivedFarmsData, userDataLoaded = farms.userDataLoaded, poolLength = farms.poolLength, regularCakePerBlock = farms.regularCakePerBlock;
        return {
            loadArchivedFarmsData: loadArchivedFarmsData,
            userDataLoaded: userDataLoaded,
            data: deserializedFarmsData,
            poolLength: poolLength,
            regularCakePerBlock: regularCakePerBlock
        };
    });
};

;// CONCATENATED MODULE: ./src/state/farms/hooks.ts



















function useFarmsLength() {
    var chainId = (0,hooks_useActiveChainId/* useActiveChainId */.g)().chainId;
    return (0,dist/* default */.Z)(chainId ? [
        "farmsLength",
        chainId
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var mc;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    mc = (0,contractHelpers/* getMasterchefContract */.aE)(undefined, chainId);
                    return [
                        4,
                        mc.poolLength()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().toNumber()
                    ];
            }
        });
    }));
}
var usePollFarmsWithUserData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var _useActiveWeb3React = (0,useActiveWeb3React/* default */.Z)(), account = _useActiveWeb3React.account, chainId = _useActiveWeb3React.chainId;
    var _useBCakeProxyContractAddress = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId), proxyAddress = _useBCakeProxyContractAddress.proxyAddress, proxyCreated = _useBCakeProxyContractAddress.proxyCreated, isProxyContractLoading = _useBCakeProxyContractAddress.isLoading;
    var farmFlag = (0,hooks_useFeatureFlag/* useFeatureFlag */.y)(hooks_useFeatureFlag/* featureFarmApiAtom */.x);
    (0,dist/* default */.Z)(chainId ? [
        "publicFarmData",
        chainId
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var farmsConfig, pids;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,farms_constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    pids = farmsConfig.map(function(farmToFetch) {
                        return farmToFetch.pid;
                    });
                    dispatch((0,farms/* fetchFarmsPublicDataAsync */.eG)({
                        pids: pids,
                        chainId: chainId,
                        flag: farmFlag
                    }));
                    return [
                        2
                    ];
            }
        });
    }), {
        refreshInterval: farmFlag === "api" ? 50 * 1000 : constants/* SLOW_INTERVAL */.KI
    });
    var name = proxyCreated ? [
        "farmsWithUserData",
        account,
        proxyAddress,
        chainId
    ] : [
        "farmsWithUserData",
        account,
        chainId
    ];
    (0,dist/* default */.Z)(account && chainId && !isProxyContractLoading ? name : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var farmsConfig, pids, params;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,farms_constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    pids = farmsConfig.map(function(farmToFetch) {
                        return farmToFetch.pid;
                    });
                    params = proxyCreated ? {
                        account: account,
                        pids: pids,
                        proxyAddress: proxyAddress,
                        chainId: chainId
                    } : {
                        account: account,
                        pids: pids,
                        chainId: chainId
                    };
                    dispatch((0,farms/* fetchFarmUserDataAsync */.IV)(params));
                    return [
                        2
                    ];
            }
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    });
};
/**
 * Fetches the "core" farm data used globally
 * 2 = CAKE-BNB LP
 * 3 = BUSD-BNB LP
 */ var coreFarmPIDs = {
    56: [
        2,
        3
    ],
    97: [
        4,
        10
    ],
    5: [
        13,
        11
    ],
    1: [
        124,
        125
    ]
};
var usePollCoreFarmData = function() {
    var dispatch = useAppDispatch();
    var chainId = useActiveChainId().chainId;
    var farmFlag = useFeatureFlag(featureFarmApiAtom);
    useEffect(function() {
        if (chainId) {
            dispatch(fetchInitialFarmsData({
                chainId: chainId
            }));
        }
    }, [
        chainId,
        dispatch
    ]);
    useFastRefreshEffect(function() {
        if (chainId && farmFlag !== "api") {
            dispatch(fetchFarmsPublicDataAsync({
                pids: coreFarmPIDs[chainId],
                chainId: chainId,
                flag: farmFlag
            }));
        }
    }, [
        dispatch,
        chainId,
        farmFlag
    ]);
};
var useFarms = function() {
    var chainId = (0,hooks_useActiveChainId/* useActiveChainId */.g)().chainId;
    return (0,es/* useSelector */.v9)((0,react.useMemo)(function() {
        return farmSelector(chainId);
    }, [
        chainId
    ]));
};
var useFarmsPoolLength = function() {
    return useSelector(function(state) {
        return state.farms.poolLength;
    });
};
var useFarmFromPid = function(pid) {
    var farmFromPid = (0,react.useMemo)(function() {
        return makeFarmFromPidSelector(pid);
    }, [
        pid
    ]);
    return (0,es/* useSelector */.v9)(farmFromPid);
};
var useFarmFromLpSymbol = function(lpSymbol) {
    var farmFromLpSymbol = useMemo(function() {
        return farmFromLpSymbolSelector(lpSymbol);
    }, [
        lpSymbol
    ]);
    return useSelector(farmFromLpSymbol);
};
var useFarmUser = function(pid) {
    var farmFromPidUser = (0,react.useMemo)(function() {
        return makeUserFarmFromPidSelector(pid);
    }, [
        pid
    ]);
    return (0,es/* useSelector */.v9)(farmFromPidUser);
};
// Return the base token price for a farm, from a given pid
var useBusdPriceFromPid = function(pid) {
    var busdPriceFromPid = useMemo(function() {
        return makeBusdPriceFromPidSelector(pid);
    }, [
        pid
    ]);
    return useSelector(busdPriceFromPid);
};
var useLpTokenPrice = function(symbol) {
    var lpTokenPriceFromLpSymbol = (0,react.useMemo)(function() {
        return makeLpTokenPriceFromLpSymbolSelector(symbol);
    }, [
        symbol
    ]);
    return (0,es/* useSelector */.v9)(lpTokenPriceFromLpSymbol);
};
/**
 * @deprecated use the BUSD hook in /hooks
 */ var usePriceCakeBusd = function() {
    var forceMainnet = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        forceMainnet: false
    }).forceMainnet;
    var price = (0,useBUSDPrice/* useCakeBusdPrice */.S9)({
        forceMainnet: forceMainnet
    });
    return (0,react.useMemo)(function() {
        return price ? new (bignumber_default())(price.toSignificant(6)) : bigNumber/* BIG_ZERO */.HW;
    }, [
        price
    ]);
};


/***/ }),

/***/ 70688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useBCakeProxyContractAddress; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5163);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3255);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57535);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56521);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57647);
/* harmony import */ var _pancakeswap_farms_src_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7527);







var useBCakeProxyContractAddress = function(account, chainId) {
    var bCakeFarmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useBCakeFarmBoosterContract */ .gh)();
    var isSupportedChain = _pancakeswap_farms_src_index__WEBPACK_IMPORTED_MODULE_4__/* .bCakeSupportedChainId.includes */ .P4.includes(chainId);
    var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(account && isSupportedChain && [
        "bProxyAddress",
        account,
        chainId
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            return [
                2,
                bCakeFarmBoosterContract.proxyContract(account)
            ];
        });
    })), data = _useSWR.data, status = _useSWR.status, mutate = _useSWR.mutate;
    var isLoading = isSupportedChain ? status !== config_constants_types__WEBPACK_IMPORTED_MODULE_3__/* .FetchStatus.Fetched */ .iF.Fetched : false;
    return {
        proxyAddress: data,
        isLoading: isLoading,
        proxyCreated: data && data !== config_constants__WEBPACK_IMPORTED_MODULE_1__/* .NO_PROXY_CONTRACT */ .h5,
        refreshProxyAddress: mutate
    };
};


/***/ }),

/***/ 93561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24826);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var react_countup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76597);







var Balance = function(_param) {
    var value = _param.value, _param_color = _param.color, color = _param_color === void 0 ? "text" : _param_color, _param_decimals = _param.decimals, decimals = _param_decimals === void 0 ? 3 : _param_decimals, _param_isDisabled = _param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled, unit = _param.unit, prefix = _param.prefix, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "value",
        "color",
        "decimals",
        "isDisabled",
        "unit",
        "prefix",
        "onClick"
    ]);
    var prefixProp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return prefix ? {
            prefix: prefix
        } : {};
    }, [
        prefix
    ]);
    var suffixProp = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return unit ? {
            suffix: unit
        } : {};
    }, [
        unit
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_countup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        start: 0,
        preserveValue: true,
        delay: 0,
        end: value
    }, prefixProp, suffixProp), {
        decimals: decimals,
        duration: 1,
        separator: ",",
        children: function(param) {
            var countUpRef = param.countUpRef;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                color: isDisabled ? "textDisabled" : color,
                onClick: onClick
            }, props), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    ref: countUpRef
                })
            }));
        }
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Balance);


/***/ }),

/***/ 10021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78545);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df4f0a61-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ })

}]);